var map = {
	"./amazon.png": "gSUk",
	"./cnet.png": "4Lq5",
	"./dashbot.png": "ZKNx",
	"./homesmart.png": "pG0l",
	"./jargon.png": "ddbA",
	"./jovo.png": "n02W",
	"./tc.png": "aY1k"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lFPR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/presslogo nonrecursive \.png$
// module id = lFPR
// module chunks = 0